"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const MoleculeGraphCertificate_vue_1 = __importDefault(require("./MoleculeGraphCertificate.vue"));
let GraphCertificateRate = class GraphCertificateRate extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.categoryDesc = '';
        this.levels = ['AAA', 'AA', 'A', 'B', 'C', 'D'];
        this.baseDim = 800;
        this.baseRadius = this.baseDim / 2;
        this.strokeWidth = this.baseDim / 10 / 2 - 10;
        this.levelPadding = 5;
        this.basicOffset = 40;
        this.pureCategories = ['A++', 'A+', 'A', 'B', 'C', 'D'];
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    get levelSelected() {
        if (this.score >= 0 && this.score <= 50) {
            this.categoryDesc = 'Harmful Farming';
            return 'D';
        }
        if (this.score > 50 && this.score <= 59) {
            this.categoryDesc = 'Intensive Farming';
            return 'C';
        }
        if (this.score > 59 && this.score <= 69) {
            this.categoryDesc = 'Integrated Farming';
            return 'B';
        }
        if (this.score > 69 && this.score <= 79) {
            this.categoryDesc = 'Equa Farming';
            return 'A';
        }
        if (this.score > 79 && this.score <= 89) {
            this.categoryDesc = 'Bio Farming';
            return 'AA';
        }
        if (this.score > 89 && this.score <= 100) {
            this.categoryDesc = 'Wild Farming';
            return 'AAA';
        }
        else {
            this.categoryDesc = 'Wild Farming';
            return 'AAA';
        }
    }
    levelSelect(level) {
        if (level == 'AAA') {
            return 1;
        }
        if (level == 'AA') {
            return 2;
        }
        if (level == 'A') {
            return 3;
        }
        if (level == 'B') {
            return 4;
        }
        if (level == 'C') {
            return 5;
        }
        if (level == 'D') {
            return 6;
        }
    }
    currRadius(index) {
        return this.baseRadius - (this.strokeWidth + this.levelPadding) * index;
    }
    arrIni(index) {
        return ((2 *
            3.141592654 *
            (this.baseRadius - (this.strokeWidth + this.levelPadding) * index)) /
            8 +
            ((2 *
                3.141592654 *
                (this.baseRadius - (this.strokeWidth + this.levelPadding) * index)) /
                8 /
                6) *
                (this.levels.length - index));
    }
    arrFin(index) {
        return (2 *
            3.141592654 *
            (this.baseRadius - (this.strokeWidth + this.levelPadding) * index) -
            (2 *
                3.141592654 *
                (this.baseRadius - (this.strokeWidth + this.levelPadding) * index)) /
                8 +
            ((2 *
                3.141592654 *
                (this.baseRadius - (this.strokeWidth + this.levelPadding) * index)) /
                8 /
                6) *
                (this.levels.length - index));
    }
    offset(index) {
        return this.arrIni(index) - this.arrFin(index) + this.basicOffset;
    }
    yText(index) {
        return 5 + index * (this.strokeWidth + this.levelPadding);
    }
    friendlyCat(cat) {
        return cat.replace(/\+/g, cat[0]);
    }
    ordToCat(order) {
        return this.pureCategories[order];
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: 0 })
], GraphCertificateRate.prototype, "score", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], GraphCertificateRate.prototype, "category", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], GraphCertificateRate.prototype, "theme", void 0);
GraphCertificateRate = __decorate([
    (0, vue_property_decorator_1.Options)({
        name: 'GraphCertificateRate',
        components: {
            MoleculeGraphCertificate: MoleculeGraphCertificate_vue_1.default,
        },
    })
], GraphCertificateRate);
exports.default = GraphCertificateRate;
